export const sharedABQueryKeyPrefixes = {
  ab: () => ['ab'] as const,
  dashboard: () => [...sharedABQueryKeyPrefixes.ab(), 'dashboard'] as const,
} as const;
